/**
 * SEO helpers: canonical + hreflang link tags injected per route + language.
 * Keeps Google from treating ?lang=uk and ?lang=ja as alternate-of-canonical-EN,
 * so each language version is indexed as its own page.
 */
import type { Language } from './i18n';

const SITE = 'https://ai.dr.vet';

function ensureLink(rel: string, hreflang?: string): HTMLLinkElement {
  const sel = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (hreflang) el.setAttribute('hreflang', hreflang);
    document.head.appendChild(el);
  }
  return el;
}

/**
 * Set canonical + hreflang for current page.
 * Canonical points to the language-specific URL (EN = clean, others = ?lang=).
 */
export function setCanonicalAndHreflang(path: string, lang: Language) {
  const clean = path.startsWith('/') ? path : `/${path}`;
  const urls: Record<string, string> = {
    en: `${SITE}${clean}`,
    uk: `${SITE}${clean}?lang=uk`,
    ja: `${SITE}${clean}?lang=ja`,
  };
  ensureLink('canonical').setAttribute('href', urls[lang] || urls.en);
  ensureLink('alternate', 'en').setAttribute('href', urls.en);
  ensureLink('alternate', 'uk').setAttribute('href', urls.uk);
  ensureLink('alternate', 'ja').setAttribute('href', urls.ja);
  ensureLink('alternate', 'x-default').setAttribute('href', urls.en);
}
